import './classList';
import './stockists';
import * as ajax from './ajax';
import './slider.js';

/* eslint-disable */
// matches polyfill
window.Element && function( ElementPrototype ) {
    ElementPrototype.matches = ElementPrototype.matches ||
    ElementPrototype.matchesSelector ||
    ElementPrototype.webkitMatchesSelector ||
    ElementPrototype.msMatchesSelector ||
    function( selector ) {
        var node = this, nodes = ( node.parentNode || node.document ).querySelectorAll( selector ), i = -1;
        while ( nodes[++i] && nodes[i] != node );
        return !!nodes[i];
    }
}( Element.prototype );

// closest polyfill
window.Element && function( ElementPrototype ) {
    ElementPrototype.closest = ElementPrototype.closest ||
    function( selector ) {
        var el = this;
        while ( el.matches && !el.matches( selector ) ) el = el.parentNode;
        return el.matches ? el : null;
    }
}( Element.prototype );
/* eslint-enable */




var navToggle = document.querySelector( '.nav-toggle' );
var nav = document.querySelector( '.nav-main' );
var body = document.querySelector( 'body' );

navToggle.addEventListener( 'click', function( e ) {

	e.preventDefault();
 
	nav.classList.toggle( 'nav-main--active' );
	navToggle.classList.toggle( 'nav-toggle--active' );
	body.classList.toggle( 'fix-body' );
} );

var overlayContainer = document.querySelector( '.overlay' );
var closeOverlay = document.querySelector( '.close_circle' );
if(closeOverlay) {
    closeOverlay.addEventListener( 'click', function( e ) {
        overlayContainer.classList.toggle( 'closed' );
    } );
} 
 

// SUB MENUS
// let submenus = document.querySelectorAll( '.nav-main .sub-menu' );

// let closeDropdowns = function() {

// 	for( let i = 0; i < submenus.length; i++ ) {

// 		submenus[i].classList.remove( 'sub-menu--active' );

// 	}

// 	document.querySelector( '.header-items' ).classList.remove( 'header-items--active' );

// };

// {

// 	let menuParents = document.querySelectorAll( '.nav-main .menu-item-has-children > a' );

// 	for( let i = 0; i < menuParents.length; i++ ) {

// 		menuParents[i].addEventListener( 'click', function( e ) {

// 			e.preventDefault();

// 			closeDropdowns();

// 			let submenu = this.closest( 'li' ).querySelector( '.sub-menu' );

// 			submenu.classList.toggle( 'sub-menu--active' );

// 		} );

// 	}

// }


// BODY CLICK TO CLOSE DROPDOWNS
// {

// 	document.body.addEventListener( 'click', closeDropdowns );

// 	let stopProp = function( e ) {

// 		e.stopPropagation();

// 	};

// 	// document.querySelector( '.nav-main' ).addEventListener( 'click', stopProp );
// 	document.querySelector( '.header__basket' ).addEventListener( 'click', stopProp );
// 	// document.querySelector( '.header-items' ).addEventListener( 'click', stopProp );

// }




// var quantityInputs = document.querySelectorAll( 'li.product .quantity input' );

// if( quantityInputs.length ) {

// 	for( let i = 0; i < quantityInputs.length; i++ ) {

// 		quantityInputs[i].addEventListener( 'input', function() {

// 			var addButton = this.closest( '.product' ).querySelector( '.add_to_cart_button' );

// 			addButton.setAttribute( 'data-quantity', this.value );

// 		} );

// 	}

// }


$('.header__basket').click(function(e){
	e.preventDefault();
	$('.header-items').toggleClass('header-items--active');
});

$(document).click(function(e) {
	if($('.header-items').hasClass('header-items--active') && !$('.header__basket').is(e.target) && !$('.header__basket *').is(e.target) && !$('.header-items--active').is(e.target)  && !$('.header-items--active *').is(e.target) ) {
		$('.header-items').removeClass('header-items--active');
	}
});


// Remove link from product archive
{

	let links = document.querySelectorAll( 'li.product > a:first-of-type' );

	if( links.length ) {

		for( let i = 0; i < links.length; i++ ) {

			let el = links[i];

			var parent = el.parentNode;
			while ( el.firstChild ) parent.insertBefore( el.firstChild, el );
			parent.removeChild( el );

		}

	}

}




// HEADER BASKET
// {
// 	let header = document.querySelector( '.header' );

// 	header.addEventListener( 'click', function( e ) {
// 		if( e.target.closest( '.header__basket' ) ) {

// 			e.preventDefault();
// 			e.stopPropagation();

// 			closeDropdowns();

// 			document.querySelector( '.header-items' ).classList.add( 'header-items--active' );
// 		}
// 	});
// }




// NEWSLETTER
var newsletters = document.querySelectorAll( '.newsletter' );
var newsletterEmails = document.querySelectorAll( '.newsletter__email' );
var newsletterButtons = document.querySelectorAll( '.newsletter__submit' );
var newsletterResponses = document.querySelectorAll( '.newsletter__response' );



function newsletter_signup(newsletter, newsletterEmail, newsletterButton, newsletterResponse) {

    newsletterButton.disabled = true;
    newsletterResponse.style.display = 'none';

    ajax.post( window.probalm.ajaxUrl, {action: 'probalm_newsletter', email: newsletterEmail.value}, function( data ) {

        newsletterButton.disabled = false;

        if( data === 'success' ) {

            let message = document.createElement( 'p' );
            message.className = 'text-center';
            message.innerHTML = 'Thanks for signing up! Please check your email inbox.';

            newsletter.parentNode.insertBefore( message, newsletter );

            newsletter.parentNode.removeChild( newsletter );

        } else {

            newsletterResponse.style.display = 'block';
            newsletterResponse.innerHTML = data;

        }

    } );

}

// loop through all newsletter classes and pass to newsletter_signup()
if( newsletters.length > 0 ) {

	for(let i=0; i < newsletters.length; i++) {
        newsletters[i].addEventListener( 'submit', function( e ) {

            e.preventDefault();

            newsletter_signup(newsletters[i], newsletterEmails[i], newsletterButtons[i], newsletterResponses[i]);

        } );
	} //end loop


}



// MODALS
{

	var modalBtns = document.querySelectorAll( '.js-modal' );

	for( let i = 0; i < modalBtns.length; i++ ) {

		modalBtns[i].addEventListener( 'click', function( e ) {

			e.preventDefault();

			let href = this.getAttribute( 'href' ) ? this.getAttribute( 'href' ) : this.getAttribute( 'data-href' );
			let modal = document.querySelector( href );

			modal.classList.add( 'modal--active' );
			modal.setAttribute( 'aria-hidden', 'false' );

			document.body.classList.add( 'modal-open' );

		} );

	}


	// CLOSE
	let closeBtns = document.querySelectorAll( '.modal__close' );

	for( let j = 0; j < closeBtns.length; j++ ) {

		closeBtns[j].addEventListener( 'click', function() {

			let modal = this.closest( '.modal' );

			modal.classList.remove( 'modal--active' );
			modal.setAttribute( 'aria-hidden', 'true' );

			document.body.classList.remove( 'modal-open' );

		} );

	}

}
// Start Functions

$(document).ready(function(){

    // test for cookie here
    if (Cookies.get('newsletter_popup') != '1') {
        //show popup here
        // console.log('No Cookies');
        $('.overlay--newsletter').addClass('open');
        

        // set cookie here if not previous set
        var date = new Date();
        var minutes = 30;
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        Cookies.set('newsletter_popup', '1', {expires: date});
   } else {
    //    console.log('Cookie Set');
   }

});

//How to video
$( document ).ready(function() {
    $('.hero--video').click(function() {
        $("body").addClass("overlayActive");
        $(".video-container").css('z-index', '10');
        $(".video-container iframe").css('z-index', '10');
        setTimeout(function(){
            $(".video-container").addClass("video-container--show");
            $(".video-container iframe").addClass("show");
        },250)
    });

  var urlDump = $('#video').attr('src');
  var url = $('#video').attr('src');

  $('.hero--video').click(function(){
	  $('#video').attr('src', urlDump);
  });

  $('.video-container__close').click(function(){
	  $('#video').attr('src', '');
      $("body").removeClass("overlayActive");
      $(".video-container").removeClass("video-container--show");
      $(".video-container iframe").removeClass("show");
      setTimeout(function(){
          $(".video-container").css('z-index', '-5');
           $(".video-container iframe").css('z-index', '-5');
      },250)
  });
});

//Product single video
$(document).ready(function(){
	$('[data-product-video-trigger]').click(function(){
		$('.overlay--video').toggleClass('open');
	});
});



/** WEBPACK FOOTER **
 ** main.js
 **/